import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Footer from '../components/footer';
import { Link } from 'wouter';
import { listOrganizationalUnits, createOrganizationalUnit } from '../services/api_org_unit';
import { AuthContext } from '../contexts/auth';
import ComboboxAutocomplete from '../components/combobox_autocomplete';
import { UsersIcon, BuildingOffice2Icon, CheckIcon, TrashIcon  } from '@heroicons/react/24/outline';
import { Listbox } from '@headlessui/react';
import { useLocation } from 'wouter';
import Swal from 'sweetalert2';
import { getEmployeesWithActiveContract } from '../services/api_calendar';
import Fetching from '../components/fetching';
import PopoverComponentCustom from '../components/popover_component';
import ListBoxQueryMultiSelectEmployeesActiveContract from '../components/list_box_query_employee_active_contract';



export const CreateOrgUnitForm = () => {
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [units, setUnits] = useState([]);
  const [selectedUnitParent, setSelectedUnitParent] = useState(null);
  const { profile, token, setProfile } = useContext(AuthContext);
  const [employeeRolePairs, setEmployeeRolePairs] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [dipendenti, setDipendenti] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [availableEmployees, setAvailableEmployees] = useState([]);
  const [error, setError] = useState('');
  const [location, setLocation] = useLocation();
  const [isSaving, setIsSaving] = useState(false);
  const [totalResult, setTotalResult] = useState(0);
  const [page, setPage] = useState(1);
  const pageSize = 50; 


  useEffect(() => {
    listOrganizationalUnits(token, true)
      .then((data) => {
        setUnits(data.data);
      })
      .catch(error => {
        console.error('Error fetching units:', error);
      });
  }, [token]); 

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    async function getData() {
        try {
            const response = await getEmployeesWithActiveContract(token, null, 'all', signal, page, pageSize);
            const employeesArray = Array.isArray(response.results) ? response.results : [];
            setDipendenti(employeesArray);
            setTotalResult(response.count);
        } catch (error) {
            console.log(error);
        }
    }

    getData();
    return () => {
        controller.abort();
    }
  }, [token]);

  const handleParentChange = (selectedParent) => {
    if (selectedParent) {
      const parentId = selectedParent;
      setParentId(parentId);
    } else {
      setParentId(null);
    }
  };
 
  useEffect(() => {
    // console.log('Selected Unit Parent:', selectedUnitParent);
  }, [selectedUnitParent]);

  const removeEmployeeRolePair = (index) => {
    const updatedPairs = [...employeeRolePairs];
    const removedPair = updatedPairs.splice(index, 1)[0];
    setEmployeeRolePairs(updatedPairs);
  
    setAvailableEmployees([...availableEmployees, { id: removedPair.employeeId, name: getEmployeeNameById(removedPair.employeeId) }]);
  };
  
  const filterAvailableEmployees = () => {
    return dipendenti.filter(
      employee => !employeeRolePairs.some(pair => pair.employeeId === employee.id)
    );
  };  

  const filteredEmployees = availableEmployees.filter(
    employee => !employeeRolePairs.some(pair => pair.employeeId === employee.id)
  );

  const handleEmployeeChange = (employee) => {
    setSelectedEmployee(employee || null);
    setError('');
  };
  
  const handleRoleChange = (index, roleId) => {
    const newPairs = [...employeeRolePairs];
    newPairs[index].roleId = roleId;
    setEmployeeRolePairs(newPairs);
    setError('');
  };
  
  const addEmployeeRolePair = () => {
    setEmployeeRolePairs([...employeeRolePairs, { employeeId: '', roleId: '' }]);
  };

  const availableRoles = [
    { id: '1', name: 'Dipendente' },
    { id: '2', name: 'Gestore' }
  ];

  const getEmployeeNameById = (id) => {
    const employee = dipendenti.find(e => e.id === id);

    if (!employee) return 'Unknown';

    if (employee.last_name && employee.first_name) {
      return `${employee.last_name} ${employee.first_name}`;
    }

    return employee.cf || 'Unknown';
  };
  
  const getRoleInfoById = (id) => {
    switch (id) {
      case '1':
        return { name: 'Dipendente', icon: <UsersIcon className='w-5 h-5 inline-block mr-2' /> };
      case '2':
        return { name: 'Gestore', icon: <BuildingOffice2Icon className='w-5 h-5 inline-block mr-2' /> };
      default:
        return { name: 'Ruolo Sconosciuto', icon: null };
    }
  };  

  const addPairToTable = () => {
    if (!selectedEmployee?.id && !selectedRole) {
      setError("Selezionare il dipendente ed il ruolo da assegnare");
      return;
    }
  
    if (!selectedEmployee.id) {
      setError("Selezionare il dipendente");
      return;
    }
  
    if (!selectedRole) {
      setError("Selezionare il ruolo");
      return;
    }
  
    let employeeId;
    if (Array.isArray(selectedEmployee)) {
      employeeId = selectedEmployee[0].id;
    } else {
      employeeId = selectedEmployee.id;
    }

    if (!employeeId) {
      setError("Dipendente selezionato non valido");
      return;
    }
  
    setEmployeeRolePairs([
      ...employeeRolePairs,
      { employeeId: employeeId, roleId: selectedRole }
    ]);
    
    setSelectedEmployee(null);
    setSelectedRole('');
    setError('');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
  
    const selectedEmployees = employeeRolePairs
      .filter(pair => pair.roleId === '1') // Ruolo "Dipendente"
      .map(pair => pair.employeeId);
  
    const selectedManagers = employeeRolePairs
      .filter(pair => pair.roleId === '2') // Ruolo "Gestore"
      .map(pair => pair.employeeId);
  
    if (selectedEmployee?.id && !selectedRole) {
      setError("Selezionare il ruolo");
      setIsSaving(false);
      return;
    }
  
    if (!selectedEmployee?.id && selectedRole) {
      setError("Selezionare il dipendente");
      setIsSaving(false);
      return;
    }
  
    if (selectedRole === '' && !selectedEmployee?.id) {
      setError('');
    }
  
    if (selectedEmployee?.id && selectedRole && employeeRolePairs.length === 0) {
      setError("Aggiungi il dipendente selezionato prima di creare l'unità");
      setIsSaving(false);
      return;
    }
  
    try {
      const response = await createOrganizationalUnit(token, {
        name,
        parent: parentId?.id,
        employees: selectedEmployees,
        managers: selectedManagers,
      });
  
      if (!response.success) {
        console.error('Errore durante la creazione dell\'unità organizzativa:', response.error);
        Swal.fire({
          text: 'Errore, riprovare più tardi',
          icon: 'error',
        });
        setIsSaving(false);
        return;
      } 

      Swal.fire({
        position: "center",
        title: "Salvato!",
        text: 'Unità Organizzativa creata con successo!',
        showConfirmButton: false,
        icon: 'success',
        timer: 2000,
      });
      const updatedUnits = await listOrganizationalUnits(token);
      setUnits(updatedUnits.data);
      setLocation('/organization');
     
    } catch (error) {
      console.error('Errore durante la creazione dell\'unità organizzativa:', error);
      Swal.fire({
        text: 'Errore, riprovare più tardi',
        icon: 'error',
      });
    } finally {
      setIsSaving(false); 
    }
  };
  
  if(isLoading)
    return <Fetching />;
  if (isError) return <div>Error loading data</div>;

  return (
    <>
      <div className='flex flex-col min-h-screen'>
        <PopoverComponentCustom title="Aggiungi Unità Organizzativa" />

        <main className="mt-10 pb-8 px-5 flex-grow">
          <div className='container mx-auto px-5 m-5'>
            <div>
              <button>
                <Link to={`/organization`} className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600 hover:bg-gray-100">Torna alle Unità Organizzative</Link>
              </button>
            </div>
            <div className='border border-gray-200 rounded-md shadow-md my-4'>
              <div className='p-5'>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 uppercase tracking-wider">Nome*</label>
                    <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className="mt-1 block w-full border border-gray-200 rounded-md shadow-md placeholder:text-gray-500 placeholder:text-sm" placeholder='Inserisci nome' required />
                  </div>
                  <div className="mb-4 z-50">
                    <label htmlFor="parent" className="block text-sm font-medium text-gray-700 uppercase tracking-wider">Unità di Appartenenza</label>
                    <div className='border border-gray-200 rounded-md shadow-md'>
                      <ComboboxAutocomplete
                        options={units}
                        bgActiveColor="bg-indigo-100"
                        placeholder='Seleziona Unità'
                        onChange={handleParentChange}
                        value={parentId}
                        positionOptions='relative'
                      />
                    </div>
                  </div>

                  <div>
                    {/* Select Dropdowns for Employee and Role */}
                    <div className="flex flex-col sm:flex-row sm:items-end sm:space-x-4">
                      <div className="w-full sm:w-2/5">
                        <label htmlFor="parent" className="block text-sm font-medium text-gray-700 uppercase tracking-wider">Dipendente</label>
                        <ListBoxQueryMultiSelectEmployeesActiveContract
                          token={token}
                          selectedEmployees={selectedEmployee ? [selectedEmployee] : []}
                          employeeRolePairs={employeeRolePairs}
                          onChange={(employees) => {
                            const employee = employees.length
                              ? employees[employees.length - 1]
                              : null;

                            setSelectedEmployee(employee);
                            setError('');
                          }}
                          placeholder="Seleziona dipendente"
                          filterBy='all'
                        />
                      </div>
                      <div className="w-full sm:w-2/5">
                        <label htmlFor="parent" className="block text-sm font-medium text-gray-700 uppercase tracking-wider">Ruolo</label>

                        <Listbox value={selectedRole} onChange={(value) => {
                          if (value === selectedRole) {
                            setSelectedRole('');
                            setError('');
                          } else {
                            setSelectedRole(value);
                          }
                        }}>
                          <div className="relative mt-4 sm:mt-0">
                            <Listbox.Button className="bg-white relative w-full shadow-md rounded-md pl-3 pr-10 py-2 text-left cursor-default sm:text-sm border border-gray-200">
                              <span className="block truncate text-gray-500 text-sm">{selectedRole ? availableRoles.find(role => role.id === selectedRole)?.name : 'Seleziona ruolo'}</span>
                              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                              </span>
                            </Listbox.Button>

                            <Listbox.Options className="absolute mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                              <Listbox.Option
                                key="placeholder"
                                value=""
                                disabled
                                className="text-gray-400 cursor-default select-none relative py-2 pl-10 pr-4"
                              >
                                Seleziona ruolo
                              </Listbox.Option>
                              {availableRoles.map((role) => (
                                <Listbox.Option
                                  key={role.id}
                                  value={role.id}
                                  className={({ active, disabled }) =>
                                    `${active ? 'bg-indigo-100' : 'text-gray-900'} ${
                                      disabled ? 'text-gray-400' : ''
                                    }
                                        cursor-default select-none relative py-2 pl-10 pr-4`
                                  }
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <span
                                        className='font-normal block truncate' 
                                      >
                                        {role.name}
                                      </span>
                                      {selected ? (
                                        <span
                                          className={`${active ? 'text-white' : 'text-indigo-500'}
                                              absolute inset-y-0 left-0 flex items-center pl-3`}
                                        >
                                          <CheckIcon className='w-5 h-5 text-indigo-800' />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </div>
                        </Listbox>
                      </div>
                      <div className="w-full sm:w-1/5">
                        <button type="button" onClick={addPairToTable} className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded-md w-full mt-4 sm:mt-0">Aggiungi</button>
                      </div>
                    </div>
                    <div className='flex justify-center'>
                      {error && <p className="text-red-500 text-sm mt-3">{error}</p>}
                    </div>
                    {/* Table for Employee-Role Pairs */}
                    <table className="min-w-full divide-y divide-gray-200 mt-4">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Nome
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Ruolo
                          </th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {employeeRolePairs.map((pair, index) => (
                          <tr key={index}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" style={{ width: '50%' }}>
                              {getEmployeeNameById(pair.employeeId)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800" style={{ width: '50%' }}>
                              {getRoleInfoById(pair.roleId).icon} {getRoleInfoById(pair.roleId).name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                              <button
                                onClick={() => removeEmployeeRolePair(index)}
                                className="text-red-600 hover:text-red-900"
                              >
                              <TrashIcon className='h-5 w-5 text-gray-800 hover:text-red-600' />
                              
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className='flex justify-center mt-4'>
                      <button
                          type="submit" 
                          className={`bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded-md ${isSaving ? 'bg-gray-400 cursor-not-allowed' : ''}`} 
                          disabled={isSaving}
                      >
                          {isSaving ? 'Salvataggio...' : 'Crea Unità Organizzativa'}
                      </button>
                    </div>
                    
                  </div>
                </form>
       
              </div>
            </div>
          </div>
        </main>

        <Footer />
     
      </div>
    </>
  );
};


